import React, { useEffect } from "react";

export const OriginLayer = props => {
    const { plot } = props;

    const layerName = "originLayer";

    useEffect(() => {
        plot.addLayer(layerName, 170);
        drawOrigin();
    }, []);

    const drawOrigin = () => {
        const layer = plot.getLayer(layerName);
        plot.addCircle(layer, 0, 0, true, { fill: "green" });
    };

    return <></>;
};